<template>
  <div class="d-flex flex-column flex-nowrap">
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">N° bon</span>
        <BaseDataV2
          :value="apport.numeroBon"
          is-secondaire
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Poids net</span>
        <BaseDataV2
          :value="apport.poidsNetEnKg | roundNumber(3, 0.001)"
          is-principal
          unit="t"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Poids aux normes</span>
        <BaseDataV2
          :value="apport.poidsAuxNormesEnKg | roundNumber(3, 0.001)"
          is-principal
          unit="t"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.poidsSpecifiqueEnKgParHectolitre)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">PS</span>
        <BaseDataV2
          :value="apport.caracteristiques.poidsSpecifiqueEnKgParHectolitre"
          unit="kg/hl"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Humidité</span>
        <BaseDataV2
          :value="apport.caracteristiques.humiditeTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Impuretés</span>
        <BaseDataV2
          :value="apport.caracteristiques.impureteTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.proteineTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Protéines</span>
        <BaseDataV2
          :value="apport.caracteristiques.proteineTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.tempsChuteHacbergEnSeconde)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Hagberg</span>
        <BaseDataV2
          :value="apport.caracteristiques.tempsChuteHacbergEnSeconde"
          unit="s"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.echaudeBriseTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Echaudé, brisé</span>
        <BaseDataV2
          :value="apport.caracteristiques.echaudeBriseTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.germeMitadineFusarieTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Germé, mitadiné, fusarié</span>
        <BaseDataV2
          :value="apport.caracteristiques.germeMitadineFusarieTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.impureteGrainTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Impureté, mitadiné, germé</span>
        <BaseDataV2
          :value="apport.caracteristiques.impureteGrainTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.mitadineTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Mitadiné</span>
        <BaseDataV2
          :value="apport.caracteristiques.mitadineTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.zelenyIndiceEnMillilitre)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Zeleny</span>
        <BaseDataV2
          :value="apport.caracteristiques.zelenyIndiceEnMillilitre"
          unit="mL"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainBrucheTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Grains bruchés</span>
        <BaseDataV2
          :value="apport.caracteristiques.grainBrucheTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesPrincipales.includes(caracteristiques.grainCasseTaux)"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Grains cassés</span>
        <BaseDataV2
          :value="apport.caracteristiques.grainCasseTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.grainGermeTaux) && apport.caracteristiques.grainGermeTaux != null"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Grains germés</span>
        <BaseDataV2
          :value="apport.caracteristiques.grainGermeTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.flairAnormal) && apport.caracteristiques.flairAnormal === true"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Présence flair anormal</span>
        <BaseDataV2
          value="Oui"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.insectePresent) && apport.caracteristiques.insectePresent === true"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="Présence insecte">Présence insecte</span>
        <BaseDataV2
          value="Oui"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.matiereGrasseTaux) && apport.caracteristiques.matiereGrasseTaux != null"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Matières grasses</span>
        <BaseDataV2
          :value="apport.caracteristiques.matiereGrasseTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.omega3Taux) && apport.caracteristiques.omega3Taux != null"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Oméga 3</span>
        <BaseDataV2
          :value="apport.caracteristiques.omega3Taux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.daturaPresent) && apport.caracteristiques.daturaPresent === true"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Présence datura</span>
        <BaseDataV2
          value="Oui"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.ergotPresent) && apport.caracteristiques.ergotPresent === true"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Présence ergot</span>
        <BaseDataV2
          value="Oui"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
        />
      </div>
    </div>
    <div
      v-if="graineRs3.caracteristiquesSecondaires.includes(caracteristiques.calibrageTaux) && apport.caracteristiques.calibrageTaux != null"
      class="ligne"
    >
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Calibrage</span>
        <BaseDataV2
          :value="apport.caracteristiques.calibrageTaux"
          unit="%"
          message="Aucune donnée"
          class="mb-md-0"
          custom-class="intro"
          :precision="1"
        />
      </div>
    </div>
    <div class="ligne">
      <div class="d-flex justify-space-between align-center">
        <span class="text-center texte texte-gris-fonce">Silo</span>
        <BaseDataV2
          :value="apport.siloDestination.libelle"
          custom-class="intro"
          class="mb-md-0"
          message="Aucune donnée"
        />
      </div>
    </div>
    <div
      v-if="!apport.sansContrat"
      class="d-flex justify-center mt-2"
    >
      <v-btn
        class="white primary--text pa-0"
        outlined
        @click="openDetailModal()"
      >
        <v-icon class="mr-2">
          mdi-information-outline
        </v-icon>
        <span class="texte primary--text">Détails</span>
      </v-btn>
    </div>

    <DetailApportModal
      v-if="isOpenModalDetailApport"
      :apport="apport"
      :is-open-modal-detail-apport="isOpenModalDetailApport"
      :loading-detail-mouvement="loadingDetailMouvement"
      :erreur-detail-mouvement="erreurDetailMouvement"
      @close="isOpenModalDetailApport = false"
    />
  </div>
</template>

<script>
import caracteristiques from '@/model/caracteristiquesGraines'
import BaseDataV2 from '@/components/common/base-data-v2.vue'
import DetailApportModal from './modal/detail-apport-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'DetailApportMobile',
  components: { BaseDataV2, DetailApportModal },
  props: {
    apport: {
      type: Object,
      default: () => { }
    },
    graineRs3: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      caracteristiques,
      isOpenModalDetailApport: false,
      loadingDetailMouvement: false,
      erreurDetailMouvement: false
     }
  },
  methods: {
    ...mapActions({
      getDetailMouvement: 'mouvement/getDetailMouvement'

    }),
    openDetailModal () {
      this.isOpenModalDetailApport = true
      this.loadDetailMouvement()
    },
    loadDetailMouvement () {
      this.loadingDetailMouvement = true
      this.erreurDetailMouvement = false

      const params = {
        numeroBon: this.apport.numeroBon,
        numeroContrat: this.apport.numeroContratCommercial
      }

      this.getDetailMouvement(params)
        .catch(() => {
          this.erreurDetailMouvement = true
        })
        .finally(() => this.loadingDetailMouvement = false)

    },
  }
}
</script>

<style scoped lang="scss">
.ligne{
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-bottom: 6px !important;
  padding-top: 6px !important;  
}

.ligne:nth-child(2n+1){
  background-color:#F1F2F5; 
  border: 1px;
  border-radius: 8px;  
}
</style>
